import {
  IOrderBalanceResponse,
  IOrderBalanceWorkbook,
} from "types/OrderBalance";

import { api } from ".";

// CLE-2849: SuperAdmin-only balance ledger. The endpoint reads Stripe/Finix live, so callers use
// the LAZY hook and fire it on demand; nothing loads it on page open, and it is never cached for long.
const orderBalanceQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrderBalance: builder.query<IOrderBalanceResponse, string>({
      query: (orderId) => ({ url: `orders/${orderId}/balance` }),
      keepUnusedDataFor: 0,
    }),
    // The same ledger as finance's audit workbook (.xlsx), fetched through the authenticated API so the
    // caller can trigger a browser save. The server builds the ledger again, so this also runs only on click.
    getOrderBalanceWorkbook: builder.query<IOrderBalanceWorkbook, string>({
      query: (orderId) => ({
        url: `orders/${orderId}/balance.xlsx`,
        responseHandler: async (response: Response) => {
          if (!response.ok) {
            try {
              return await response.json();
            } catch {
              return { message: "Could not build the workbook." };
            }
          }
          return {
            blob: await response.blob(),
            fileName: `order-balance-${orderId}.xlsx`,
          };
        },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useLazyGetOrderBalanceQuery,
  useLazyGetOrderBalanceWorkbookQuery,
} = orderBalanceQueries;
